export function formatCents(cents: number): string {
  const sign = cents < 0 ? '-' : '';
  const abs = Math.abs(cents);
  const euros = Math.floor(abs / 100)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${sign}${euros},${String(abs % 100).padStart(2, '0')} €`;
}

/**
 * Deutsches Datum + Uhrzeit ohne Sekunden, mit expliziten 2-digit-Optionen: ohne sie liefert
 * `toLocaleDateString('de-DE')` je nach ICU den Monat nicht nullgepolstert (aus MyHours).
 */
export function formatTimestamp(iso: string): string {
  const d = new Date(iso);
  const date = d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const time = d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
  return `${date} ${time}`;
}

export function formatUserName(user: { givenName?: string; familyName?: string; email: string }) {
  const name = [user.givenName, user.familyName].filter(Boolean).join(' ');
  return name || user.email;
}

/**
 * Deutscher Betrag in Cent: "15.000,00", "15000", "-2.500,5" oder "−2.500 €". Liefert
 * `undefined`, wenn die Eingabe kein Betrag ist.
 */
export function parseEuroCents(input: string): number | undefined {
  const s = input.trim().replace(/€/g, '').replace(/\s/g, '').replace(/−/g, '-');
  if (!/^-?\d{1,3}(\.\d{3})*(,\d{1,2})?$|^-?\d+(,\d{1,2})?$/.test(s)) return undefined;
  const [euros, cents = ''] = s.replace(/\./g, '').split(',');
  const sign = euros!.startsWith('-') ? -1 : 1;
  return sign * (Math.abs(Number(euros)) * 100 + Number(cents.padEnd(2, '0')));
}
